<template>
   <div class='population-card'>
      <infographics-card-header :title="data.title"/>
      <div class='select-wrapper'>
         <select-input
            v-model="selectedYear"
            font-family="'Montserrat', Arial, 'sans-serif'"
            :options="years.map(year => ({title: year, value: year}))"
         />
      </div>
      <vue-scroll>
         <div class="body">
            <infographics-item
               v-for="item in currentData"
               :key="item.id"
               :item="item"
            />
         </div>
      </vue-scroll>
   </div>
</template>

<script>
import InfographicsCardHeader from '../../../molecules/Home/InfographicsCardHeader';
import InfographicsItem from '../../../molecules/Home/InfographicsItem';
import SelectInput from '../../../atoms/Home/SelectInput';

export default {
   name: 'population-card',
   components: {
      InfographicsCardHeader,
      InfographicsItem,
      SelectInput,
   },
   props: {
      data: {
         type: Object,
         required: true,
         validator: data => data.title && data.items && data.items instanceof Array,
      }
   },
   data() {
      return {
         selectedYear: 2011,
      }
   },
   computed: {
      currentData()
      {
         const currentYearData = this.data.items.find(item => item.year===parseInt(this.selectedYear));
         if (!currentYearData) return [];
         return [
            {id: 1, value: currentYearData.total, title: 'Total Population', icon_url: '/icons/total.svg'},
            {id: 2, value: currentYearData.male, title: 'Male', icon_url:  '/icons/male.svg'},
            {id: 3, value: currentYearData.female, title: 'Female', icon_url: '/icons/female.svg'},
         ];
      },
      years()
      {
         return this.data.items.map(item => item.year);
      }
   }
}
</script>

<style lang='scss' scoped>
.select-wrapper {
   padding: 5px 10px 10px 10px;
}
</style>